import { api } from "../api/apiClient";

const handleError = (error) => {
  console.error("Error:", error);
  throw error;
};

// Convert gender array to string format for API requests
const formatGender = (gender) => {
  return Array.isArray(gender) ? `{${gender.join(",")}}` : gender;
};

// Format date as local datetime string without timezone conversion
// This ensures "6:00 PM" is stored as "18:00" not converted to UTC
const formatLocalDate = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const searchLinkups = async (searchTerm, userId, gender) => {
  try {
    const response = await api.get(`/api/linkup/linkups/search/${userId}`, {
      params: {
        search_term: searchTerm,
        gender: formatGender(gender), // Format gender for API
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getLinkups = async (
  userId,
  gender,
  sqlOffset,
  pageSize,
  latitude,
  longitude,
) => {
  try {
    const response = await api.get(`/api/linkup/linkups/${userId}`, {
      params: {
        gender: formatGender(gender), // Format gender for API
        offset: sqlOffset,
        pageSize: pageSize,
        latitude: latitude,
        longitude: longitude,
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getUserLinkups = async (userId) => {
  try {
    const response = await api.get(`/api/linkup/linkups/user/${userId}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getLinkupStatus = async (linkupId) => {
  try {
    const response = await api.get(`/api/linkup/linkups/status/${linkupId}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const createLinkup = async (linkUpData) => {
  try {
    const response = await api.post(`/api/linkup/linkups/create`, {
      linkup: {
        ...linkUpData,
        date: formatLocalDate(linkUpData.date),
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteLinkup = async (linkupId) => {
  try {
    const response = await api.delete(`/api/linkup/linkups/${linkupId}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const closeLinkup = async (linkupId) => {
  try {
    const response = await api.post(`/api/linkup/linkups/close/${linkupId}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateLinkup = async (linkupId, linkupData) => {
  try {
    const response = await api.post(`/api/linkup/linkups/update/${linkupId}`, {
      linkup: {
        ...linkupData,
        date: linkupData.date ? formatLocalDate(linkupData.date) : undefined,
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
